import { Link } from "react-router-dom";
import "../../styles/Pages/APropos/APropos.css";
import heroPanelImage from "../../assets/aboutus/bandereau.png";
import archPanelImage from "../../assets/aboutus/merefils.png";
import wavePanelImage from "../../assets/aboutus/dernierimgabout.png";

export default function APropos() {
  return (
    <main className="apropos">
      <div className="apropos__shell">
        <header className="apropos__hero">
          <p className="apropos__kicker">À propos</p>
          <h1 className="apropos__title">
            VERTYNO : créateur de douceur et de sérénité
          </h1>
          <div className="apropos__hero-panel" aria-hidden="true">
            <img src={heroPanelImage} alt="" />
          </div>
        </header>

        <section className="apropos__split" aria-labelledby="apropos-aventure">
          <div className="apropos__split-art apropos__split-art--arch" aria-hidden="true">
            <img src={archPanelImage} alt="" />
          </div>
          <div className="apropos__split-copy">
            <h2 id="apropos-aventure" className="apropos__h2">
              L’aventure VERTYNO : pourquoi nous existons
            </h2>
            <div className="apropos__prose">
              <p>
                Tout a commencé par une envie simple : transformer les petits défis du quotidien en moments de
                pur bonheur. En tant que parents, nous savons que chaque étape de la journée — du repas
                mouvementé au coucher parfois difficile — est une aventure.
              </p>
              <p>
                VERTYNO est né pour accompagner ces instants avec des solutions qui allient design, sécurité et
                ingéniosité. Nous ne vendons pas simplement des objets, nous sélectionnons des alliés pour votre
                vie de famille.
              </p>
            </div>
          </div>
        </section>

        <section className="apropos__split apropos__split--reverse" aria-labelledby="apropos-mission">
          <div className="apropos__split-copy">
            <h2 id="apropos-mission" className="apropos__h2 apropos__h2--wide">
              Notre mission : simplifier, rassurer, éveiller
            </h2>
            <div className="apropos__prose">
              <p>
                Que ce soit pour apaiser les nuits de vos petits avec nos veilleuses iconiques (Lili, Mochi ou
                Dino) ou pour rendre les repas plus sereins avec nos assiettes en bambou à succion
                anti-renversement, nous avons une obsession : la qualité.
              </p>
              <p>
                Nous choisissons des matériaux sains, durables et pensés pour la sécurité de vos enfants, afin que
                vous puissiez vous concentrer sur l’essentiel : créer des souvenirs avec eux.
              </p>
            </div>
          </div>
          <div className="apropos__split-art apropos__split-art--wave" aria-hidden="true">
            <img src={wavePanelImage} alt="" />
          </div>
        </section>

        <section className="apropos__pillars" aria-labelledby="apropos-philosophie">
          <div className="apropos__pillars-intro">
            <h2 id="apropos-philosophie" className="apropos__h2 apropos__h2--center">
              La philosophie VERTYNO : transparence et proximité
            </h2>
            <p className="apropos__lead">
              Nous croyons qu’une belle expérience d’achat commence par la clarté. Chez nous, pas de frais cachés
              ni de mauvaises surprises.
            </p>
          </div>

          <ul className="apropos__grid">
            <li className="apropos__card">
              <span className="apropos__card-icon" aria-hidden="true" />
              <h3 className="apropos__h3">Le prix juste</h3>
              <p>Nous proposons nos produits phares au prix unique de 21,90&nbsp;€.</p>
            </li>
            <li className="apropos__card">
              <span className="apropos__card-icon" aria-hidden="true" />
              <h3 className="apropos__h3">Livraison sérénité</h3>
              <p>
                Pour vous simplifier la vie, la livraison en point relais via Chrono Shop2Shop est toujours
                offerte.
              </p>
            </li>
            <li className="apropos__card">
              <span className="apropos__card-icon" aria-hidden="true" />
              <h3 className="apropos__h3">Engagement français</h3>
              <p>
                VERTYNO est une entreprise française (SASU) basée à Rosny-sous-Bois. Nous gérons chaque commande
                avec le soin qu’elle mérite.
              </p>
            </li>
          </ul>
        </section>

        <aside className="apropos__cta" aria-labelledby="apropos-ecoute">
          <div className="apropos__cta-inner">
            <h2 id="apropos-ecoute" className="apropos__cta-title">
              Toujours à votre écoute
            </h2>
            <p className="apropos__cta-text">
              Parce que derrière chaque écran il y a une famille, nous mettons un point d’honneur à rester
              disponibles. Vous avez une question sur une matière, une utilisation ou une livraison ? Nous vous
              répondons directement, sans intermédiaire. Écrivez-nous depuis la page 
              <Link to="/Contact" className="apropos__cta-link">
                 Contact
              </Link>
              .
            </p>
          </div>
        </aside>

        <section className="apropos__legal" aria-labelledby="apropos-infos-title">
          <h2 id="apropos-infos-title" className="apropos__legal-title">
            Informations officielles
          </h2>
          <dl className="apropos__dl">
            <div className="apropos__dl-row">
              <dt>Société</dt>
              <dd>VERTYNO SASU</dd>
            </div>
            <div className="apropos__dl-row">
              <dt>Siège social</dt>
              <dd>9 Allée Gabriel Zirnhelt, 93110 Rosny-sous-Bois, France</dd>
            </div>
            <div className="apropos__dl-row">
              <dt>Service client</dt>
              <dd>
                <a href="tel:+33661050571">06 61 05 05 71</a>
              </dd>
            </div>
            <div className="apropos__dl-row">
              <dt>E-mail</dt>
              <dd>
                <a href="mailto:contact@vertyno.com">contact@vertyno.com</a>
              </dd>
            </div>
          </dl>
        </section>

        <p className="apropos__signoff">
          Merci de faire partie de l’aventure VERTYNO et de nous laisser entrer dans votre foyer.
        </p>
      </div>
    </main>
  );
}
